import { Modal } from '@/core/components/Modal';
import { HEADER_HEIGHT } from '@/core/components/Layout/Layout.styles';
import { useTopmostZIndex } from '@/core/hooks/useTopmostZIndex';

import { EditAnalysis } from './EditAnalysis';
import { ContentInner, ModalContent } from './EditAnalysis.styles';

type EditAnalysisModalProps = {
  isOpen: boolean;
  onClose: () => void;
  analysisId?: number | null;
  onDeleteSuccess?: () => void;
};

export const EditAnalysisModal = ({
  isOpen,
  onClose,
  analysisId = null,
  onDeleteSuccess,
}: EditAnalysisModalProps) => {
  const zIndex = useTopmostZIndex(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      matchContentSize={false}
      height={`calc(100vh - ${HEADER_HEIGHT})`}
      zIndex={zIndex}
      positionX="flex-end"
      positionY="flex-start"
      overlayPosition={{
        top: HEADER_HEIGHT,
        right: '0',
        left: '0',
      }}
    >
      <ModalContent>
        <ContentInner>
          <EditAnalysis
            analysisId={analysisId}
            onClose={onClose}
            onDeleteSuccess={onDeleteSuccess}
          />
        </ContentInner>
      </ModalContent>
    </Modal>
  );
};
